import { SafeResourceUrl } from '@angular/platform-browser';
import { SpecialDiscountStatusEnum, SpecialDiscountTypeEnum } from 'app/models';

export class XpressUserProfile {
    public Id: number | undefined = undefined;
    public ImageUrl: string | null = '';
    public ImageData: string | null = '';
    public CompanyName: string | null = '';
    public FirstName: string | null = '';
    public LastName: string | null = '';
    public OperatorCode: string | null = '';
    public Email: string | null = '';
    public Address: string | null = '';
    public BirthDate!: Date;
    public Sex: string | null = '';
    public Gender: number = 0;
    public Phone: string = '';
    public TimeZoneOffset: number = 0;
    public TaxNumber: string | null = '';
    public BankTypeId: number = 0;
    public BankName: string | null = '';
    public AccountNumber: string | null = '';
    public AccountName: string | null = '';
    public SaveOnlyImageLinks: boolean = false;
    public SignUpDate!: Date;
    public LastActive!: Date;
    //docs
    public GovIdUrls: string[] = [];
    public DTIorSECCertifUrls:  string[] = [];
    public BIRCertifUrls:  string[] = [];
    public LTFRBCertifUrls:  string[] = [];
    public BusinessPermitUrls:  string[] = [];
    public GovIdData: File[] = [];
    public BIRCertifData: File[] = [];
    public BusinessPermitData: File[] = [];
    public DTIorSECCertifData: File[] = [];
    public LTFRBCertifData: File[] = [];
    //security
    public Password: string = '';
    public NewPassword: string = '';
    public ConfirmPassword: string = '';
    public GovPdfUrl!: SafeResourceUrl;
    public DTIorSECPdfUrl!: SafeResourceUrl;
    public BIRPdfUrl!: SafeResourceUrl;
    public LTFRBPdfUrl!: SafeResourceUrl;
    public BusinessPermitPdfUrl!: SafeResourceUrl;


    public static SpecialDiscountStatusList: Array<any> = [
        { name: 'None', value: SpecialDiscountStatusEnum.None },
        { name: 'Fully Verified', value: SpecialDiscountStatusEnum.FullyVerified },
        { name: 'NotVerified', value: SpecialDiscountStatusEnum.NotVerified },
        { name: 'Rejected', value: SpecialDiscountStatusEnum.Rejected }
    ];

    public static SpecialDiscountTypeList: Array<any> = [
        { name: 'All', value: SpecialDiscountTypeEnum.None },
        { name: 'Person With Disabilities', value: SpecialDiscountTypeEnum.PersonWithDisabilities },
        { name: 'Student', value: SpecialDiscountTypeEnum.Student },
        { name: 'Senior Citizen', value: SpecialDiscountTypeEnum.SeniorCitizen },
        { name: 'Athlete', value: SpecialDiscountTypeEnum.Athlete },
        { name: 'Coach', value: SpecialDiscountTypeEnum.Coach }
    ];
}
